import { useEffect, useState } from 'react';

const WINDOW_RESIZE_EVENT = 'resize';

function getWindowHeight(): number {
    return window.innerHeight;
}

export function useWindowHeight(): number {
    const [windowHeight, setWindowHeight] = useState(getWindowHeight());

    useEffect(() => {
        const handleWindowResize = (): void => setWindowHeight(getWindowHeight());

        window.addEventListener(WINDOW_RESIZE_EVENT, handleWindowResize);

        return () => window.removeEventListener(WINDOW_RESIZE_EVENT, handleWindowResize);
    }, []);

    return windowHeight;
}
